import { Link, useLocation } from "react-router-dom";
import { LEGAL_CONTACT, LEGAL_UPDATED_AT } from "./legal-config";
import LegalPageLayout, { LegalCallout, LegalSection } from "./LegalPageLayout";

export default function CGV() {

const location = useLocation();
const legalState = location.state?.legalOrigin === "profile" ? { legalOrigin: "profile", from: "/profil" } : null;

  return (
    <LegalPageLayout
      title="Conditions générales de vente"
      topbarTitle="Conditions de vente"
      lead="Ces conditions encadrent l’accès au Refuge Personnel, son essai gratuit, son renouvellement et les droits attachés aux contenus numériques proposés par Harmonauria."
      updatedAt={LEGAL_UPDATED_AT}
    >
      <LegalSection
        number="01"
        title="Identité du vendeur et champ d’application"
      >
        <p>Les présentes conditions générales de vente s’appliquent aux abonnements souscrits auprès de {LEGAL_CONTACT.publisherName}, entrepreneur individuel, SIRET {LEGAL_CONTACT.siret}, pour l’accès à l’offre payante Harmonauria appelée <strong>Le Refuge Personnel</strong>.</p>
        <p>Elles complètent les informations présentées au moment de la commande. En cas de contradiction, les informations tarifaires et la durée affichées dans le parcours de souscription avant validation de la commande prévalent pour la commande concernée.</p>
      </LegalSection>

      <LegalSection
        number="02"
        title="Le service Harmonauria"
      >
        <p>Harmonauria est un refuge numérique qui réunit des respirations guidées, des paysages sonores, des guides pratiques, des outils de progression et un accompagnement personnalisé pour vous aider à retrouver calme et détente.</p>
        <p>Une partie du service peut être accessible gratuitement. Le Refuge Personnel ouvre l’accès aux fonctionnalités et contenus indiqués dans l’offre présentée avant la souscription.</p>
        <LegalCallout title="Bien-être et santé">
          <p>Harmonauria est un service de bien-être. Il ne constitue pas un dispositif médical, ne réalise aucun diagnostic et ne remplace pas l’avis ou l’accompagnement d’un professionnel de santé.</p>
        </LegalCallout>
      </LegalSection>

      <LegalSection
        number="03"
        title="Compte et commande"
      >
        <ul className="legal-list">
          <li>La souscription nécessite un compte Harmonauria et des informations exactes.</li>
          <li>La commande est récapitulée avant paiement et devient définitive après validation du parcours Stripe.</li>
          <li>La confirmation de souscription et les informations contractuelles sont envoyées ou rendues accessibles sur un support durable.</li>
          <li>Les identifiants de compte sont personnels et ne doivent pas être partagés.</li>
        </ul>
      </LegalSection>

      <LegalSection
        number="04"
        title="Essai gratuit, prix et renouvellement"
        highlight
      >
        <p>Lorsque l’offre le prévoit et sous réserve d’éligibilité, Le Refuge Personnel commence par un essai gratuit de sept jours. Aucun prélèvement n’est effectué avant la fin de cet essai.</p>
        <ul className="legal-list">
          <li><strong>Formule mensuelle :</strong> 6,99 € par mois après l’essai gratuit.</li>
          <li><strong>Formule annuelle :</strong> 59,88 € par an après l’essai gratuit, soit un équivalent de 4,99 € par mois.</li>
          <li>Les prix sont indiqués en euros, toutes taxes comprises lorsque celles-ci sont applicables.</li>
          <li>L’abonnement se renouvelle automatiquement à chaque échéance jusqu’à sa résiliation.</li>
          <li>Le prix, la durée de l’essai et la périodicité sont rappelés avant la confirmation de la commande.</li>
        </ul>
      </LegalSection>

      <LegalSection
        number="05"
        title="Paiement"
      >
        <p>Les paiements sont traités par Stripe au moyen des modes de paiement proposés au moment de la commande. Harmonauria ne reçoit pas le numéro complet de la carte bancaire.</p>
        <p>En cas d’échec de paiement, Stripe peut effectuer de nouvelles tentatives et l’accès au Refuge Personnel peut être suspendu jusqu’à régularisation.</p>
      </LegalSection>

      <LegalSection
        number="06"
        title="Résiliation"
      >
        <p>L’abonnement est sans engagement au-delà de la période choisie. Vous pouvez demander sa résiliation depuis la page Profil ou le portail client Stripe accessible depuis votre compte.</p>
        <ul className="legal-list">
          <li>Une résiliation pendant l’essai empêche le premier prélèvement, tout en maintenant l’accès jusqu’à la date de fin d’essai indiquée.</li>
          <li>Une résiliation après paiement empêche le renouvellement suivant. L’accès reste actif jusqu’à la fin de la période déjà payée.</li>
          <li>La réception de la demande et la date d’effet de la résiliation doivent être confirmées.</li>
        </ul>
      </LegalSection>

      <LegalSection
        number="07"
        title="Droit de rétractation"
      >
        <p>En principe, un consommateur dispose d’un délai de quatorze jours à compter de la conclusion d’un contrat à distance pour exercer son droit de rétractation, sans avoir à justifier sa décision.</p>
        <p>Pour un contenu numérique fourni sans support matériel, la perte de ce droit avant la fin du délai n’est possible que lorsque l’exécution a commencé après votre <strong>accord préalable exprès</strong> et votre <strong>renoncement exprès</strong> au droit de rétractation, puis lorsque ces éléments sont confirmés sur un support durable.</p>
        <p>La simple souscription ou l’accès immédiat ne doit donc pas être présenté, à lui seul, comme une renonciation automatique.</p>
        <p>Les modalités et le formulaire de rétractation figurent dans la <Link to="/legal/remboursement" state={legalState}>politique d’annulation, de résiliation et de remboursement</Link>.</p>
      </LegalSection>

      <LegalSection
        number="08"
        title="Garantie légale de conformité numérique"
      >
        <p>Les contenus et services numériques payants bénéficient de la garantie légale de conformité dans les conditions prévues par le Code de la consommation. Pour un abonnement continu, cette garantie s’applique pendant la période de fourniture.</p>
        <p>En cas de défaut de conformité, vous pouvez demander la mise en conformité du service. Lorsque celle-ci est impossible, tardive ou vous cause un inconvénient majeur, une réduction du prix ou la résolution du contrat peut être demandée dans les conditions légales.</p>
      </LegalSection>

      <LegalSection
        number="09"
        title="Disponibilité et évolution du service"
      >
        <p>Harmonauria peut évoluer afin d’améliorer la sécurité, la simplicité ou la qualité du refuge. Les interruptions temporaires liées à la maintenance, à un incident ou à un prestataire externe ne constituent pas automatiquement un défaut ouvrant droit à remboursement, sans préjudice des garanties légales applicables.</p>
        <p>Une modification substantielle défavorable d’un service numérique continu est communiquée dans les conditions prévues par la réglementation.</p>
      </LegalSection>

      <LegalSection
        number="10"
        title="Usage personnel et propriété intellectuelle"
      >
        <p>L’accès est accordé pour un usage personnel et non commercial. Il est interdit de copier, télécharger hors des fonctions prévues, redistribuer, revendre, diffuser publiquement, entraîner un système automatisé ou exploiter commercialement les contenus sans autorisation écrite.</p>
      </LegalSection>

<LegalSection
  number="11"
  title="Réclamations et droit applicable"
>
  <p>Toute réclamation peut être adressée à <a href={`mailto:${LEGAL_CONTACT.email}`}>{LEGAL_CONTACT.email}</a>. Une réponse amiable sera recherchée avant tout autre recours.</p>
  <p>Les présentes conditions sont soumises au droit français, sans priver un consommateur résidant dans un autre État de l’Union européenne des dispositions impératives plus protectrices de son pays de résidence.</p>
</LegalSection>
    </LegalPageLayout>
  );
}
